$(".faq .faq-item .faq-question i").click(function(){
    var faqItem = $(this).closest('.faq-item');
    // 切换 faq-item 的 active 类
    faqItem.toggleClass('active').siblings('.faq-item').removeClass('active');
})
$('.tab .item').click(function(){
	$(this).addClass('active').siblings().removeClass('active')
	console.log($(this).index())
	if($(this).index()){
		$('.tab .slider').addClass('active')
	}else{
		$('.tab .slider').removeClass('active')
	}
	$('.buy_box').eq($(this).index()).addClass('active').siblings('.buy_box').removeClass('active')
})

// ga跟踪代码
function gaPush(dataEvent,lable){
    try{
        // _gaq.push(['_trackEvent',operation,String(dataEvent),String(lable)]);
    }catch(e){
        // console.log(e)
    }
}
// 购买
var isbuy=0;
if(location.hostname=='www.anyrec.io'
){
    var paddle_vendor=133788;
}else{
    Paddle.Environment.set('sandbox');
    var paddle_vendor=570;
}
Paddle.Setup({
    vendor: paddle_vendor,
    eventCallback: function(data) {
        console.log(data);
        $('.buy_box .btn a').removeClass('load');
        if(data.event === 'Checkout.PaymentMethodSelected'){
            if(!buy_first){
                gaPush('buy_payment_first','')
            }else{
                gaPush('buy_payment','')
            }
        }
        if (data.event === 'Checkout.PaymentComplete') {
            isbuy=1;
            gaPush('buy_success','')
        }
        if(data.event === 'Checkout.Close'&&isbuy){
            $('.maskRights').show();
            if(getCookie('user')){
                // $('.buySuccess.Member').show().siblings().hide();
                gaPush('buy_login','true')
            }else{
                // $('.buySuccess.noMember').show().siblings().hide();
                gaPush('buy_login','false')
            }
        }
        if(data.event === 'Checkout.Error'){
            gaPush('buy_fail','')
        }
    }
});
$('.buy_box .btn a').click(function(){
    if($(this).hasClass('load')){
        return false;
    }
    checkout($(this));
})
function checkout(that){
    var data={
        e_id:murmur,
        gateway:gateway,
        plan_id:that.attr('plan'),
    }
    gaPush('buy_fail','buy_planID',that.attr('plan'))
    that.addClass('load')
    $.post(
        post_url+"subscription/checkout",
        data,
        function(data){
            error_fn(data.error,that);
            switch(data.error){
                case 0:
                    if(gateway==4){
                        // 2checkout
                        (function (document, src, libName, config,data) {
                            var data=getUrlkey(data.url_gateway)
                            var script             = document.createElement('script'); 
                            script.src             = src; 
                            script.async           = true; 
                            script.id              ='buy2checkout'
                            var firstScriptElement = document.getElementsByTagName('script')[0]; 
                            script.onload          = function () {
                                $('.buy_box .btn a').removeClass('load');
                                var isbuy=0;
                                for (var namespace in config) {
                                    if (config.hasOwnProperty(namespace)) {
                                        window[libName].setup.setConfig(namespace, config[namespace]);
                                    } 
                                } 
                                window[libName].register();
                                TwoCoInlineCart.products.add({
                                    code: data.prod,
                                    quantity: data.qty,
                                });
                                try{
                                    if(data.test){
                                        TwoCoInlineCart.cart.setTest(true);
                                    }
                                }catch(e){
                                    console.log(e)
                                }
                                if(data.lock){
                                    TwoCoInlineCart.cart.setCartLockedFlag(true)
                                }else{
                                    TwoCoInlineCart.cart.setCartLockedFlag(false);
                                }
                                if(data['empty-cart']){
                                    TwoCoInlineCart.cart.setReset(true)
                                }else{
                                    TwoCoInlineCart.cart.setReset(false)
                                }
                                TwoCoInlineCart.cart.setExpiration(data.expiration)
                                TwoCoInlineCart.cart.setSignature(data.signature)
                                // TwoCoInlineCart.cart.setOrderExternalRef(data['order-ext-ref'])
                                TwoCoInlineCart.cart.setExternalCustomerReference(data['customer-ext-ref'])
                                TwoCoInlineCart.cart.checkout();
                                TwoCoInlineCart.events.subscribe('cart:opened', function () {
                                    console.log('cart:opened')
                                })
                                TwoCoInlineCart.events.subscribe('cart:closed', function () {
                                    if(isbuy){
                                        $('.maskRights').show();
                                        if(getCookie('user')){
                                            $('.buySuccess.Member').show().siblings().hide();
                                            gaPush('buy_login','true')
                                        }else{
                                            $('.buySuccess.noMember').show().siblings().hide();
                                            gaPush('buy_login','false')
                                        }
                                    }
                                })
                                TwoCoInlineCart.events.subscribe('payment:finalized', function () {
                                    isbuy=1;
                                    gaPush('buy_success','')
                                })
                            }; 
                            firstScriptElement.parentNode.insertBefore(script, firstScriptElement); 
                        })(document, 'https://secure.2checkout.com/checkout/client/twoCoInlineCart.js', 'TwoCoInlineCart',{"app":{"merchant":getUrlkey(data.url_gateway).merchant,"iframeLoad":"checkout"},"cart":{"host":"https:\/\/secure.2checkout.com","customization":"inline"}},data); 
                    }else if(gateway==6){
                        $('.maskRights').show()
                        if(getCookie('user')){
                            $('.buySuccess.Member').show().siblings().hide();
                        }else{
                            $('.buySuccess.noMember').show().siblings().hide();
                        }
                        console.log("3",newWindow);
                        newWindow.location.href = data.url_gateway;
                    }else if(gateway==7){
                        var key=JSON.parse(window.atob(data.url_gateway.split('base64,')[1]));
                        console.log(key);
                        if(fastspringScript){
                            $('.purchase_box .btn').removeClass('load');
                            fastspring.builder.secure(key.p,key.k)
                            fastspring.builder.checkout();
                        }else{
                            fastspringScript=document.createElement('script'); 
                            fastspringScript.src="https://sbl.onfastspring.com/sbl/1.0.1/fastspring-builder.min.js"; 
                            fastspringScript.async=true; 
                            fastspringScript.id='fsc-api'
                            fastspringScript.setAttribute('data-storefront',fast_storefront)
                            fastspringScript.setAttribute('data-access-key',fast_key)
                            fastspringScript.setAttribute('data-access-key',fast_key)
                            fastspringScript.setAttribute('data-popup-closed','dataPopupClosed')
                            fastspringScript.setAttribute('data-popup-webhook-received','dataPopupWebhookReceived')
                            document.body.appendChild(fastspringScript)
                            fastspringScript.onload=function(){
                                $('.purchase_box .btn').removeClass('load');
                                fastspring.builder.secure(key.p,key.k)
                                fastspring.builder.checkout();
                            }
                        }
                    }else{
                        isbuy=0;
                        Paddle.Checkout.open({
                            override: data.url_gateway
                        });
                    }
                    break
                case 25301:
                    that.removeClass('load')
                    error(i18n[lang].error_25301);
                    break;
                case 25302:
                    that.removeClass('load')
                    error(i18n[lang].error_25302);
                    break;
                case 25303:
                    that.removeClass('load')
                    error(i18n[lang].error_25303);
                    break;
                case 25304:
                    that.removeClass('load')
                    error(i18n[lang].error_25304);
                    break;
                case 25305:
                    that.removeClass('load')
                    error(i18n[lang].error_25305);
                    break;
                case 25306:
                    that.removeClass('load')
                    error(i18n[lang].error_25306);
                    break;
            }
        }
    ).error(function(xhr){
        that.removeClass('load')
        overtime(25399);
    });
}